var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"logo",style:({ width: _vm.width }),attrs:{"alt":"Snitch","src":"/assets/logo/white.full.svg"},on:{"click":function($event){return _vm.$router.push('/')}}})}
var staticRenderFns = []

export { render, staticRenderFns }